<template>
  <div class="loginIndexBG" style="margin:0 auto;">

    <div class="h-topbar">
      <div class="h-topbar-expandIcon">
        <img src="../assets/logo.png"  style="height: 30px;">
        <span></span>营销开发平台
      </div>
      <div class="h-topbar-tool" ref="topbarTool">
        <h-menu theme="dark" mode="horizontal">
          <!-- <span  class="pT"  @click="helpHandler">帮助与支持</span> -->
          <span class="pT"  @click="openHandler">登录</span>
          <!-- <span class="pT"  @click="logonHandler">注册</span> -->
        </h-menu>
      </div>
    </div>


    <div class="contentBoxS">
      <div class="iconL"></div>
      <div class="iconRT"></div>
      <div class="iconRB"></div>



      <div class="contentBox">
        <div class="contentBoxT">
          <div class="iconWay"></div>
          <div class="iconCooperate"></div>
          <div class="iconYou"></div>


          <div class="contentBoxTTC">
            <div class="contentBoxTT">
              <span class="ballQiu"></span>

              <div class="ballQiuT">寻找营销活动开发合作伙伴</div>
            </div>
            <div class="contentBoxTc">互利共赢</div>

          </div>


        </div>

      </div>
      <div class="contentBoxC">
          <div class="contentBoxCC">
            我们能做什么
          </div>
      </div>
      <div class="activityBox">
          <div class="activityBoxL">
            <div class="activityBoxT">提供的服务</div>
            <div class="activityBoxLC">
              <div class="activityBoxLCt" style="padding-top:25px;">H5小活动</div>
              <div class="activityBoxLCt">APP内嵌小活动</div>
              <div class="activityBoxLCt">微信小程序</div>
              <div class="activityBoxLCt">支付宝小程序</div>
              <div class="activityBoxLCt">百度小程序</div>
            </div>
          </div>
          <div class="activityBoxR">
            <div class="activityBoxT">涉及的行业</div>
            <div class="activityBoxRc">
              <div class="bond">
                <div class="activityBoxTt">证券</div>
              </div>
              <div class="fund">
                <div class="activityBoxTt" style=" margin-top:20px;">基金</div>
              </div>
              <div class="bank">
                <div class="activityBoxTt">银行</div>
              </div>
            </div>
          </div>
      </div>
      <div class="contentBoxC">
          <div class="contentBoxCC adwantage">
            我们的优势
          </div>
      </div>

      <div class="skillBox">
        <div class="skillBoxL">
          <div class="skillBoxLc">
            <div class="skillBoxLcQ">
              <span class="shu">1</span>
            </div>
            <div class="skillBoxLcT">提高开发效率，降低活动开发成本</div>
          </div>

          <div class="skillBoxLc">
            <div class="skillBoxLcQ">
              <span class="shu">2</span>
            </div>
            <div class="skillBoxLcT">约束活动开发规范，提供活动开发指导</div>
          </div>

          <div class="skillBoxLc">
            <div class="skillBoxLcQ">
              <span class="shu">3</span>
            </div>
            <div class="skillBoxLcT">服务复用</div>
          </div>
        </div>
        <div class="skillBoxR"></div>
      </div>

      <div class="footerBox">
          <div class="footerBoxL">
            <div class="footerBoxLT">友情链接</div>
            <div class="footerBoxLTc">
              <div class="footerBoxLTcc">
                <div class="footerBoxLTcct mov" @click="hengsHandler()">恒生电子</div>
                <div class="mov" @click="gtnHandler()">GTN平台</div>
              </div>
              <div class="footerBoxLTcc">
                <div class="footerBoxLTcct mov" @click="zhHandler()">智汇云平台</div>
                <div class="mov"  @click="lighHandler()">LIGHT平台</div>
              </div>
            </div>
          </div>


          <div class="footerBoxL my">
            <div class="footerBoxLT">联系我们</div>
            <div class="footerBoxLTc">
              <div class="footerBoxLTcc me">
                <div class="footerBoxLTcct"><span class="icon iphone" ></span>0571-26693504 （09:00-17:00）</div>
                <div><span class="icon mail" ></span>xiaoyingjia@hundsun.com</div>
              </div>
              <div class="footerBoxLTcc">
                <div class="footerBoxLTcct"><span class="icon qq" ></span>客服QQ: 2235689515</div>
                <div><span class="icon dizhi" ></span>杭州市滨江区江南大道3588号恒生大厦</div>
              </div>
            </div>
          </div>


          <div class="footerBoxR">
            <div class="footerBoxRc"></div>
            <div class="footerBoxRcv">扫码关注</div>
          </div>
      </div>


    </div>









         <!--   特殊奖励设置弹框 -->
    <h-msg-box v-model="editVisable" style="width: 400px;">
      <p style="font-size: 20px;text-align: center;color:#495060;margin-bottom: 10px;">小营加营销开发平台</p>
      <h-form ref="editFormBox" style="margin: 0 10px" :model="editForm" :label-width="90" :rules="editRules">
        <h-form-item  label="手机号码" prop="continnue_days" required>
          <h-input v-model="editForm.name" placeholder="请输入手机号码" ></h-input>
        </h-form-item>
        <div style="position: relative;height: 60px;width: 100%">
            <h-form-item  label="图片验证码" prop="continnue_days" required style="position: absolute;z-index: 10;float: left;width: 340px;">
            <h-input v-model="editForm.name"  placeholder="请输入图片验证码"></h-input>
          </h-form-item>
          <span style="position: absolute;left:340px; float: left; display:inline-block;background: red;  width: 95px;height: 32px;border-radius: 4px;">
            <img :src="verifyCodeSrc">
          </span>
        </div>

        <div style="position: relative;height: 60px;width: 100%">
          <h-form-item  label="手机验证码" prop="continnue_days" required style="position: absolute;z-index: 10; float: left;width: 340px">
            <h-input v-model="editForm.name"  placeholder="手机验证码" ></h-input>
          </h-form-item>
          <h-button style="position: absolute;left: 340px; float: left;width: 95px;text-align: center;" type="primary" >获取验证码</h-button>
        </div>


        <h-form-item  label="密码" prop="continnue_days" required>
          <h-input v-model="editForm.name" placeholder="请输入密码" ></h-input>
        </h-form-item>
        <h-form-item  label="确认密码" prop="continnue_days" required>
          <h-input v-model="editForm.name" placeholder="请输入确认密码" ></h-input>
        </h-form-item>

      </h-form>
      <div slot="footer" style="text-align: center;">

        <h-button type="primary" style="width: 80%;" @click="submitAddorEdit()">注册</h-button>
      </div>
    </h-msg-box>


  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LockScreen from '@/components/LockScreen'
import fetch from '@/api/httpFetch.js'
import { allToggleClass } from '@/utils'
 import {rServiceValidate,getResourceMenu } from "@/api/bizApi/commonUtil";
// import secret from '../../../secret/secret.js'
export default {
  data() {

    let options={


      verifyCodeSrc:'',//图片验证码
      editVisable:false,
      locationHost:'',//
      locationProtocol:'',//获取协议
      URL:'',
      ticket:'',
      service:'',
      setPassword: false,
      submitLoading: true,
      locktime: this.LOCAL_CONFIG.LOCK_TIME,
      theme: this.LOCAL_CONFIG.THEME,
      sysName: this.LOCAL_CONFIG.SYS_NAME,
      appname: '',
      canPage: true,
      isComputed: false,
      editForm:{
        name:''
      },
      editRules: {

          equityName:[
            {type: 'string', max: 30, message: '权益类型名称不能超过30字', trigger: 'blur'}
          ],
          equityRemark:[
            {type: 'string', max: 50, message: '权益类型备注不能超过50字', trigger: 'blur'}
          ]

        },
      appList: [{
          value: 'tip1',
          label: '搜索提示1'
        },
        {
          value: 'tip2',
          label: '搜索提示2'
        },
        {
          value: 'tip3',
          label: '搜索提示3'
        }
      ],
      allAppList: [],
      navWidth: 0,
      showMore: false,
      hideNavList: [],
      userName: ''
    }
    // options.verifyCodeSrc='';//图片验证码
    return options
  },
  components: {
    LockScreen,
    // Topbar
  },

  computed: {
    ...mapGetters([
      'permission_routers',
      'menusRoot',
      'activeIndex'
    ]),
    hideNavListLength() {
      return this.hideNavList.length
    }
  },
  watch: {
    theme() {
      allToggleClass(document.getElementsByTagName('html')[0], this.theme)
    },
    setPassword(val) {
      if (!val) {
        this.$refs.setPassForm.resetFields()
      }
    },
    hideNavListLength(val) {
      if (val > 0) {
        this.showMore = true
      } else {
        this.showMore = false
      }
    }
  },
  methods: {
    //登录按钮函数
    openHandler(){
      // window.location.href=window.LOCAL_CONFIG.LOGINURL+'/iuccasserver/login?service=http://gdll.sit.hs.net:8080/loginIndex'
      window.location.href=window.LOCAL_CONFIG.LOGINURL+'/iuccasserver/login?service='+this.service
    },
    //注册按钮函数
    logonHandler(){
       window.location.href=window.LOCAL_CONFIG.LOGONURL+'/site/register.htm?service=http://gdll.sit.hs.net:8080'
    },
    createCode() {
      // this.$store.dispatch('GetVerifyCode',uri).then((res) => {
        //   this.loading = false;
      //   console.log(res)
      //       // console.log("跳转到主页")
      //       verifyCode.src = uri;
      //     }).catch(err => {
        //        reject(error);
      //     })
      // this.data.checkcodeurl=LOCAL_CONFIG.API_HOME + '/verify_code.jpg?t=' + (new Date()).getTime();
      fetch.get('/user/verify_code').then(response => {
       // sessionStorage['codeId']=response.data.data.codeId;
        this.verifyCodeSrc="data:image/jgp;base64,"+response.data.data.imageIo;
      })
    },
    //用户中心登录函数登录函数
    getServiceValidate() {
        let data = {
         ticket:this.ticket,
         service:this.service
         // service:'http://gdll.sit.hs.net:8080/loginIndex'
        };

        rServiceValidate(data).then(res => {

          if (res.data.errcode == '0') {
            console.log(res.data.data)
            console.log(res.data.data.token)
            sessionStorage['roles'] = JSON.stringify([res.data.data.role])
            sessionStorage['token'] = res.data.data.token
            //存入前端缓存
            sessionStorage['username'] = res.data.data.username
            sessionStorage['userId'] = res.data.data.userid;
            sessionStorage['userType'] = res.data.data.userType;
            // debugger
            // this.$router.push({path:'/mainIndex'})

            //window.location.href='http://gdll.sit.hs.net:8080/#/mainIndex'
           window.location.href=window.location.href.split("#")[0]+'#/mainIndex'

          } else {
            this.$message({
              type: 'fail',
              message: res.data.errmsg
            })
          }
        }).catch(error => {

        })



      },
    //恒生电子链接
    hengsHandler(){
      window.open("http://www.hundsun.com");

    },
    //GTN平台链接
    gtnHandler(){
       window.open("https://www.hs.net");
    },
    //智汇云
    zhHandler(){
      window.open("https://ito.hs.net/itopc");
    },
    //智汇云
    lighHandler(){
      window.open("https:www.lightyy.com");
    },
    GetQueryString(name) {
      //获取URL参数
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return decodeURI(r[2]);
      return null;
    },

       //添加系统函数
      // getMenu() {
      //   getResourceMenu().then((res) => {
      //     console.log(res)
      //     if(res.data.errcode == '0'){
      //       console.log(res.data)
      //     }else {
      //       this.$message({
      //         type: 'fail',
      //         message: res.data.errmsg
      //       })

      //     }
      //     this.editVisable = false;
      //     this.dataChange(1);

      //   });

      // },
    // 换肤
    handleChangeTheme(color) {
      this.theme = color
    },
    activeSidebar(index) {
      if (index >= 0) {
        this.$store.dispatch('ActiveRootIndex', index)
      }
      // let item = this.menusRoot[this.activeIndex]
      // 防止页面刷新时会跳转根页面
      // if(this.$route.matched[0].path !== item.url) {
      //   this.$router.push({path: item.url})
      // }
    },

    scroll(num) {
      let _this = this;
      if (num <= 1 && _this.canPage) {
        _this.canPage = false;
        let length = _this.appList.length;
        setTimeout(() => {
          let arr = _this.allAppList.slice(length, length + 10);
          if (arr.length > 0) {
            _this.appList = _this.appList.concat(arr);
            _this.canPage = true;
          } else {
            this.isComputed = true
          }
        }, 200);
      }
    },
    //帮助与支持按钮函数
    helpHandler(){
        window.open(window.location.href.split("#")[0]+'#/help',"_blank");
    },

    computedNavWidth() {
      this.hideNavList = []
      if (this.$refs.topbarNav) {
        let logoWidth = this.$refs.topbarLogo ? this.$refs.topbarLogo.clientWidth : 0
        let toolWidth = this.$refs.topbarTool ? this.$refs.topbarTool.clientWidth : 0
        let searchWidth = this.$refs.topbarSearch ? this.$refs.topbarSearch.clientWidth : 0
        this.navWidth = document.getElementsByClassName('h-topbar')[0].clientWidth - logoWidth - toolWidth - searchWidth - 20
        let that = this
        this.$nextTick(function() {
          // 对nav menu子元素从后往前遍历，将超出部分保存至hideNavList
          // menu总长度 that.$refs.topbarNav.children[0].children.length === that.menusRoot.length
          let menuRootWidth = document.getElementsByClassName('h-topbar-navMenu')[0].clientWidth
          // menu子元素
          let menuChildren = document.getElementsByClassName('h-topbar-navMenu')[0].children
          if (menuChildren && menuChildren.length > 0 && that.navWidth < menuRootWidth) {
            for (let i = menuChildren.length - 1; i >= 0; i--) {
              if (that.navWidth < menuRootWidth) {
                that.hideNavList.splice(0, 0, that.menusRoot[i])
              } else {
                break
              }
              menuRootWidth = menuRootWidth - menuChildren[i].clientWidth
            }
          }
        })
      }
    },

  },
  created() {
		let xyjId=sessionStorage['xyj']||''
		if(xyjId=='xyj'){
			this.$router.replace({ path: '/clogin' });
		}
    // this.getMenu();
    this.createCode();
    this.URL = window.location.href;
    this.locationHost=window.location.host;
    this.locationProtocol=window.location.protocol;
    this.ticket=this.GetQueryString('ticket');
    if(this.ticket){
      this.service=this.URL.split('?')[0];
      this.getServiceValidate();
    }else{
      this.service=this.URL.split('#')[0];
      //  this.getServiceValidate();
    }

  },
  mounted() {
    document.getElementsByTagName('html')[0].className=this.theme;
    document.getElementsByTagName('html')[0].style.padding='0';


  }
}

</script>
<style scoped lang="scss">
.loginIndexBG{
  background:#E9EEF4;
}
.h-topbar{
  position: fixed;
  z-index: 10;
  width: 100%;
  height: 64px;
  background:linear-gradient(190deg,rgba(33,15,217,1) 0%,rgba(38,59,243,1) 100%);
}
.h-topbar-tool{
  right: 203px;
}
.h-topbar-expandIcon{
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight:400;
  color:#fff;
  margin-left:203px;
}
.h-topbar-expandIcon span{
  display: inline-block;
  height: 18px;
  line-height: 18px;
  border-left:1px solid #fff;
  margin:0 20px;

}
.pT{
  color: #fff;
  text-align: left;
  padding-bottom: 0;
  font-size: 14px;
  margin-bottom: 10px;
  margin-right:20px;
  font-weight: 400;
}
.pT:hover,.mov:hover{
  cursor:pointer
}
.contentBoxS{
  position: relative;
  padding-top: 64px;
}
.contentBox{

}
.contentBoxT{
  position: relative;
  height: 466px;
  background: url("../assets/topBg.png") center no-repeat;
  background-size: cover;
}
.iconWay{
  position: absolute;
  right: 209px;
  top:27px;
  display: inline-block;
  width: 98px;
  height: 71px;
  background: url("../assets/icon_way.png") center no-repeat;
  background-size: cover;
}
.iconCooperate{
  position: absolute;
  left: 168px;
  bottom:0px;
  display: inline-block;
  width: 332px;
  height: 173px;
  background: url("../assets/icon_cooperate.png") center no-repeat;
  background-size: cover;
}
.iconYou{
  position: absolute;
  right: 145px;
  bottom:-90px;
  display: inline-block;
  width: 268px;
  height: 268px;
  background: url("../assets/icon_you.png") center no-repeat;
  background-size: cover;
}


.contentBoxTT{
  font-size:50px;
  font-weight:600;
  width: 376px;
  position: relative;
  top:100px;
  margin:0 auto;
  color:rgba(255,255,255,1);
  line-height:70px;
  padding-top:194px;
}

.ballQiu{
  position: absolute;
  left:0;
  top:67px;
  display: inline-block;
  width: 58px;
  height: 53px;
  background: url("../assets/icon_ball.png") center no-repeat;
  background-size: cover;
}
.ballQiuT{
  position: absolute;
  z-index: 8;
  top:55px;
  right:0;
  font-size:28px;
  font-weight:600;
  color:rgba(255,255,255,1);

}

.contentBoxTc{
  font-size:20px;
 font-weight:400;
 padding-top:36px;
 color:rgba(255,255,255,1);
 line-height:28px;
}



.contentBoxCC{
  width: 347px;
  height: 90px;
  margin:0 auto;
  margin-top:56px;
  background: url("../assets/icon_welcome.png") center no-repeat;
  background-size: cover;
  font-size:28px;
  font-weight:600;
  color:rgba(85,94,110,1);
  line-height:90px;
}
.contentBoxCC.adwantage{
  background: url("../assets/icon_adwantage.png") center no-repeat;
  background-size: cover;
}


.activityBox{
  overflow: hidden;
  width: 782px;
  margin:0 auto;
  margin-top: 26px;
  margin-bottom:40px;
}
.activityBoxL{
  float: left;
  width: 255px;
}
.activityBoxR{
  float: left;
  width: 497px;
  margin-left:30px;
}
.activityBoxT{
  font-size:17px;
  font-weight:600;
  color:rgba(70,128,255,1);
  line-height:24px;
  margin-bottom:10px;
}
.activityBoxLC{
  width: 255px;
  height: 222px;
 background: url("../assets/activityBoxBg.png") center no-repeat;
  background-size: cover;
}
.activityBoxLCt{
  font-size:11px;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height:16px;
  margin-bottom: 14px;
}
.activityBoxRc{
  position: relative;

}
.bond{
  float: left;
  width: 145px;
  height: 166px;
  background: url("../assets/icon_bond.png") center no-repeat;
  background-size: cover;
}
.fund{
  float: left;
  width: 172px;
  height: 195px;
  background: url("../assets/icon_fund.png") center no-repeat;
  background-size: cover;
}
.bank{
  float: left;
  width: 134px;
  height: 152px;
  background: url("../assets/icon_bank.png") center no-repeat;
  background-size: cover;
}
.activityBoxTt{
  font-size:16px;
  font-weight:600;
  color:rgba(255,255,255,1);
  line-height:23px;
  margin-top:40px;
}


.skillBox{
  overflow: hidden;
  width: 698px;
  margin:0 auto;
  margin-top:32px;
  margin-bottom:58px;
}
.skillBoxL{
  float: left;
  width: 284px;
  height: 245px;
  text-align: left;
}
.skillBoxLc{
  display: flex;
  align-items:center;/*垂直居中*/
  width: 284px;
  height: 63px;
  border-radius: 2px;
  border:1px solid rgba(70,128,255,0.5);
  margin-bottom: 23px;
}
.skillBoxLcQ{
   position: relative;
  display: inline-block;
  width: 45px;
  height: 42px;
  background: url("../assets/icon_ball.png") center no-repeat;
  background-size: cover;
  margin-right:11px;
}
.skillBoxLcT{
  line-height: 63px;
  font-size:11px;
  font-weight:500;
  color:rgba(85,94,110,1);
}
.shu{
  position: absolute;
  top:-12px;
  left:20px;
  height:39px;
  font-size:28px;
  font-weight:500;
  color:rgba(51,51,51,1);
  line-height:39px;
}
.skillBoxR{
  float: left;
  width: 400px;
  height: 245px;
  margin-left:12px;
  background: url("../assets/icon_liu.png") center no-repeat;
  background-size: cover;
}

.footerBox{
  height: 170px;
  padding-top:33px;
  overflow: hidden;
  background:rgba(51,51,51,1);
}
.footerBoxL{
  float: left;
  margin-left: 219px;
  font-size:8px;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height:11px;
}
.footerBoxL.my{
  margin-left:56px;
  font-size:8px;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height:11px;
}


.footerBoxLT{
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255,255,255,1);
  line-height: 20px;
}
.footerBoxLTc{
  overflow: hidden;
  margin-top: 21px;
}
.footerBoxLTcc{
  float: left;
  margin-right:15px;
  font-size: 14px;
  font-weight: 500;
  color: rgba(255,255,255,1);
  line-height: 20px;
}
.footerBoxLTcc.me{
  margin-right: 37px;
  text-align: left;
}

.footerBoxLTcct{
  margin-bottom: 11px;
  text-align: left;
}
.icon{
  display: inline-block;
  margin-right:7px;
}
.iphone{
  width: 10px;
  height: 10px;
  background: url("../assets/icon_iphone.png") center no-repeat;
  background-size: cover;
}
.qq{
  width: 10px;
  height: 11px;
  background: url("../assets/icon_qq.png") center no-repeat;
  background-size: cover;
}
.mail{
  width: 10px;
  height: 8px;
  background: url("../assets/icon_mail.png") center no-repeat;
  background-size: cover;
}
.dizhi{
  width: 10px;
  height:11px;
  background: url("../assets/icon_dizhi.png") center no-repeat;
  background-size: cover;
}
.footerBoxR{
  float: right;
  margin-right: 219px;
}
.footerBoxRc{
  width: 89px;
  height:89px;
  background: url("../assets/icon_qrcode2.jpg") center no-repeat;
  background-size: cover;
}
.footerBoxRcv{
  font-size:14px;
  font-weight:500;
  color:rgba(255,255,255,1);
  line-height:20px;
}
.iconL{
  position: absolute;
  left:0;
  bottom:608px;
  width: 85px;
  height:96px;
  background: url("../assets/icon_l.png") center no-repeat;
  background-size: cover;
}
.iconRT{
  position: absolute;
  right:0;
  bottom:927px;
  width: 85px;
  height:92px;
  background: url("../assets/icon_rt.png") center no-repeat;
  background-size: cover;
}
.iconRB{
  position: absolute;
  right:0;
  bottom:379px;
  width: 85px;
  height:91px;
  background: url("../assets/icon_rb.png") center no-repeat;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// src/views/LoginIndex.vue